export default __webpack_public_path__ + "static/error_image.png";